<template>
  <user-list-for-admin v-if="isAdmin" />
  <customer-user-list  v-else />
</template>
  
<script>
/*
BMM : jihee.kim@bespinglobal.com
AM : ripple31@nate.com
BS : may.kim@bespinglobal.com
BM : boyoung.lee@bespinglobal.com
*/

import { mapGetters } from 'vuex'
import { AUTH_GROUP } from '../../constants/constants'
import UserListForAdmin from './components/UserListForAdmin'
import CustomerUserList from './components/CustomerUserList'


export default {
  name: 'user-list',
  componentName: 'UserList',
  components:  {
    UserListForAdmin,
    CustomerUserList
  },
  computed: {
    ...mapGetters('user', ['userInfo']),
    isAdmin () {
      return this.userInfo.auth === AUTH_GROUP.BespinAdmin
    }
  },
}

</script>

<style>
 .secondary- > span {
  max-width: 170px;
  white-space:nowrap;
  display:block;
  overflow:hidden;
  text-overflow:ellipsis
  
}
</style>


// WEBPACK FOOTER //
// src/pages/user/UserList.vue